module.exports = __webpack_public_path__ + "img/李东坡.fc0ff995.png";